const options = {
  themes: ['numbers', 'icons'],
  numberOfPlayers: [1, 2, 3, 4],
  gridSizes: ['4x4', '6x6'],
};

export default options;
